import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import isEmpty from 'lodash/isEmpty';
import classname from 'classname';
import 'react-select/dist/react-select.css';
import _get from 'lodash/get';

const propTypes = {
	input: PropTypes.object,
	searchable: PropTypes.bool,
	meta: PropTypes.object,
	name: PropTypes.string,
	options: PropTypes.array,
	placeholder: PropTypes.string,
	multi: PropTypes.bool,
	className: PropTypes.string,
	clearable: PropTypes.bool
};

const defaultProps = {
	clearable: false
};

const customOptionPropTypes = {
	onFocus: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
	option: PropTypes.object,
	onSelect: PropTypes.func
};

const Select = props => {
	const { touched, error, active} = props.meta;

	const className = classname({
		'form-element-select': true,
		'is-active': isActive(props),
		[props.className ? props.className : null]: !!props.className
	});
	const placeholder = active && props.searchable ?
		`` : props.placeholder;
	const optionWithClass = _get('props.options[0].className') &&
		{ optionComponent: CustomClassOption };
	return (
		<div className={className}>
			<ReactSelect
				name={props.name}
				placeholder={placeholder}
				options={props.options}
				searchable={!!props.searchable}
				clearable={props.clearable}
				multi={!!props.multi}
				joinValues={true}
				{...optionWithClass}
				{...props.input}
				onBlur={() => {
					props.input.onBlur(props.input.value);
				}}
			/>
			{touched && error && <span className="error">{error}</span>}
		</div>
	);
};

const CustomClassOption = props => {
	const handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		props.onSelect(props.option, event);
	};
	const handleMouseEnter = (event) => {
		props.onFocus(props.option, event);
	};
	const handleMouseMove = (event) => {
		props.onFocus(props.option, event);
	};
	return (
		<div
			className={`${props.className} ${props.option.className}`}
			onMouseDown={handleMouseDown}
			onMouseEnter={handleMouseEnter}
			onMouseMove={handleMouseMove}
			title={props.option.title}
		>
			{props.children}
		</div>
	);
};

CustomClassOption.propTypes = customOptionPropTypes;
const isActive = props => props.meta.active || !isEmpty(props.input.value);

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default Select;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/multiselect/select.js